'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ERR_EMPTY_FIELD = exports.ERR_EMPTY_FIELD = ' field is empty. ';
var ERR_REPEATED_FIELD = exports.ERR_REPEATED_FIELD = ' already exist. ';
var ERR_UNIQ_FIELD = exports.ERR_UNIQ_FIELD = ' field must be unique. ';
var ERR_MANDATORY_FIELD = exports.ERR_MANDATORY_FIELD = ' field is mandatory. ';
var ERR_MISS_MARKING_ID = exports.ERR_MISS_MARKING_ID = 'Please enter a MARKING ID for each one of the templates';


//////////////////
// WEBPACK FOOTER
// ./src/constants/errorMsgs.js
// module id = 349
// module chunks = 0